import React, { Component, PropTypes } from 'react'
import EditAddresses from './edit-addresses'
import Tooltip from '../tooltip'
import { lang } from '../../strings'
import { format } from '../../utils/string'
import { formatDate } from '../../utils/date'

export default class Addresses extends Component {
  constructor(props) {
    super(props)
    this.state = this.makeInitialState(props)
  }

  makeInitialState(props) {
    return {
      editAddresses: false,
    }
  }

  render() {
    let { deliveryAddress, invoiceAddresses } = this.props
    let { editAddresses } = this.state
    let { id, hasActiveAddressChangeTask, task } = deliveryAddress
    return (
      <div>
        <a
          href='#'
          className='link'
          style={{ float: 'right' }}
          onClick={this.showEditAddresses}
        >
          {lang.customer.addresses.edit.button}
        </a>
        <h2 className='h5 color-dark-blue'>{lang.customer.addressTitle}</h2>
        <table className='mp-table'>
          <tbody>
            <tr key={id}>
              <td style={{ verticalAlign: 'top' }}>
                <strong>{lang.customer.address}</strong>{' '}
                {hasActiveAddressChangeTask ? this.renderInfo(task) : null}
              </td>
              {this.renderCareOf(deliveryAddress)}
            </tr>
            {invoiceAddresses.map(invoiceAddress => {
              return (
                <tr key={invoiceAddress.id}>
                  <td style={{ verticalAlign: 'top' }}>
                    <strong>{lang.customer.invoiceAddress}</strong> (
                    {invoiceAddress.customerNumber}){' '}
                    {invoiceAddress.hasActiveAddressChangeTask
                      ? this.renderInfo(invoiceAddress.task)
                      : null}
                  </td>
                  {this.renderCareOf(invoiceAddress)}
                </tr>
              )
            })}
          </tbody>
        </table>
        {editAddresses ? (
          <EditAddresses
            onSubmit={this.updateAddresses}
            onClose={this.hideEditAddresses}
            invoiceAddresses={invoiceAddresses}
            deliveryAddress={deliveryAddress}
          />
        ) : null}
      </div>
    )
  }

  renderCareOf(address) {
    return address.careOf ? (
      <td>
        {address.careOf} <br />
        {address.addressLine1} <br />
        {address.postCode} {address.area}{' '}
      </td>
    ) : (
      <td>
        {address.addressLine1} <br />
        {address.postCode} {address.area}{' '}
      </td>
    )
  }

  renderInfo(task) {
    let tip = format(
      lang.customer.tasks.addressChange,
      task.newAddress,
      formatDate(task.activationDate, 'LL')
    )
    return <Tooltip tip={tip} />
  }

  updateAddresses = data => {
    this.setState({ editAddresses: false })
    this.props.updateAddresses(data)
  }

  showEditAddresses = ev => {
    ev.preventDefault()
    this.setState({ editAddresses: true })
  }

  hideEditAddresses = ev => {
    ev.preventDefault()
    this.setState({ editAddresses: false })
  }
}

Addresses.propTypes = {
  deliveryAddress: PropTypes.object.isRequired,
  invoiceAddresses: PropTypes.array.isRequired,
  updateAddresses: PropTypes.func.isRequired,
}
